(function () {
  "use strict";
  if (window.__beScripts) return;
  window.__beScripts = true;

  function initReveals() {
    var els = document.querySelectorAll("[data-be-reveal]");
    if (!els.length) return;
    if (typeof IntersectionObserver === "undefined") {
      els.forEach(function (el) { el.classList.add("is-visible"); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-visible");
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05, rootMargin: "0px 0px -2% 0px" });
    els.forEach(function (el) { io.observe(el); });
    setTimeout(function () {
      els.forEach(function (el) {
        if (!el.classList.contains("is-visible") && el.getBoundingClientRect().top < window.innerHeight) {
          el.classList.add("is-visible");
        }
      });
    }, 6000);
  }

  function initHero() {
    document.querySelectorAll("[data-be-hero]").forEach(function (root) {
      var slides = root.querySelectorAll(".be-hero-inm__slide");
      var bars = root.querySelectorAll(".be-hero-inm__progress > span");
      var caps = root.querySelectorAll(".be-hero-inm__cap");
      if (slides.length < 2) return;
      var dur = (parseFloat(root.getAttribute("data-dur")) || 6) * 1000;
      var current = 0;
      var timer = null;
      root.style.setProperty("--be-hero-dur", dur + "ms");

      function toggle(list, n) {
        list.forEach(function (el, k) { el.classList.toggle("is-active", k === n); });
      }
      function show(n) {
        toggle(slides, n);
        toggle(caps, n);
        bars.forEach(function (bar, k) {
          bar.classList.remove("is-active");
          bar.classList.toggle("is-done", k < n);
        });
        if (bars[n]) {
          void bars[n].offsetWidth;
          bars[n].classList.add("is-active");
        }
        current = n;
      }
      function start() {
        clearInterval(timer);
        timer = setInterval(function () { show((current + 1) % slides.length); }, dur);
      }

      show(0);
      start();
      document.addEventListener("visibilitychange", function () {
        if (document.hidden) clearInterval(timer); else start();
      });
    });
  }

  function safe(fn, name) {
    try { fn(); } catch (e) { console.warn("[" + name + "]", e); }
  }

  function boot() {
    safe(initReveals, "initReveals");
    safe(initHero, "initHero");
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
